<template>
  <div class="users w-100 mt-10">
    <!--begin:Team-->
    <div class="text-dark mr-2 font-size-lg font-weight-bolder pb-4">
      {{ $t('detail.stash.users') }}
    </div>
    <div
      class="d-flex flex-wrap align-items-center"
      v-if="userList && userList.length > 0"
    >
      <div
        class="symbol-group symbol-hover mr-2"
        v-for="user in userList"
        :key="`${user.id}`"
        @click.stop
      >
        <div
          class="symbol symbol-50 symbol-sm flex-shrink-0 cursor-pointer"
          data-toggle="tooltip"
          v-b-tooltip.hover.top="user.username"
        >
          <div class="symbol-label">
            {{ user.username | shortName }}
          </div>
        </div>
      </div>
      <div
        class="symbol symbol-50 symbol-sm flex-shrink-0 symbol-light cursor-pointer"
        data-toggle="tooltip"
        v-b-tooltip.hover.top="
          `${$t(showMore == false ? 'filters.showAll' : 'global.close')}`
        "
        v-if="accountUsers.length > userShowLimit"
        @click="showMore = !showMore"
      >
        <div class="symbol-label">
          <i
            :class="[
              'gray-icon fas',
              {
                'fa-chevron-down': !showMore,
                'fa-chevron-up': showMore,
              },
            ]"
          ></i>
        </div>
      </div>
    </div>
    <!--end:Team-->
  </div>
</template>

<script>
export default {
  name: 'AccountUsersMin',
  props: {
    accountUsers: Array | String,
  },
  data() {
    return {
      userShowLimit: 5,
      showMore: false,
    }
  },
  computed: {
    userList() {
      if (
        this.accountUsers &&
        !this.showMore &&
        this.accountUsers.length > this.userShowLimit
      ) {
        return this.accountUsers.slice(0, this.userShowLimit)
      }
      return this.accountUsers
    },
  },
  filters: {
    shortName(name) {
      if (name && name.length > 0) {
        let shortName = ''
        name
          .split('@')[0]
          .split('.')
          .forEach((element) => {
            shortName += element.substring(0, 1)
          })

        return shortName.toUpperCase()
      } else return '-'
    },
  },
}
</script>
